import { store } from "../redux/store";
import { addNotification } from "../redux/slice/NotificationSlice";
import { handleLogoutAndRedirect } from "../redux/api";
import { commonToast } from "../Components/common";
import { API_URL } from "../utils/config";

let socket = null;

export const connectNotificationSocket = () => {
    console.log('checking-connection??')
    if (socket && socket.readyState === WebSocket.OPEN) return;
    
    const protocol = API_URL.startsWith("https") ? "wss" : "ws";
    
    // Extract accessToken from cookies
    const getAccessToken = () => {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'accessToken') {
                return value;
            }
        }
        return null;
    };
    
    const accessToken = getAccessToken();
    const baseUrl = `${protocol}://${API_URL.replace(/^https?:\/\//, '').replace('/api', '')}ws/notifications/`;
    const socketUrl = accessToken ? `${baseUrl}?accessToken=${accessToken}` : baseUrl;
    console.log('socketUrl', socketUrl)
    socket = new WebSocket(socketUrl);

    socket.onopen = () => {
        console.log("🔔 Notification WebSocket connected");
    };

    socket.onmessage = (event) => {
        console.log("MSG:", event.data);
        const data = JSON.parse(event.data);

        store.dispatch(addNotification(data));
    };

    socket.onclose = (event) => {
        console.log("🔕 Notification WebSocket closed", event.code);
        socket = null;
    };
};

export const disconnectNotificationSocket = () => {
    socket?.close();
    socket = null;
};
